import { render, staticRenderFns } from "./study_item.vue?vue&type=template&id=12f8d9f9&scoped=true&"
import script from "./study_item.vue?vue&type=script&lang=ts&"
export * from "./study_item.vue?vue&type=script&lang=ts&"
import style0 from "./study_item.vue?vue&type=style&index=0&id=12f8d9f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f8d9f9",
  null
  
)

export default component.exports